import { useEffect, useState } from "react";
import client from "@/api/client";

export function PhotoThumb({ path, alt, testId, size = "h-16 w-16" }) {
  const [url, setUrl] = useState(null);
  const [fullUrl, setFullUrl] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let active = true;
    let objectUrl;
    client
      .get(`${path}?thumb=true`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => {});
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  const openFull = () => {
    client
      .get(path, { responseType: "blob" })
      .then((res) => {
        setFullUrl(URL.createObjectURL(res.data));
        setOpen(true);
      })
      .catch(() => {});
  };

  if (!url) return <div className={`${size} rounded bg-slate-100 animate-pulse`} data-testid={testId} />;

  return (
    <>
      <img
        src={url}
        alt={alt}
        onClick={openFull}
        data-testid={testId}
        className={`${size} rounded object-cover cursor-pointer border border-slate-200 hover:opacity-90`}
      />
      {open && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center"
          onClick={() => setOpen(false)}
          data-testid="photo-lightbox"
        >
          <img src={fullUrl || url} alt={alt} className="max-h-[90vh] max-w-[90vw] rounded" />
        </div>
      )}
    </>
  );
}
